<template>
  <div class="company-page-view">
    <div class="nav-page-box">
      <nav-page-view
      ></nav-page-view>
    </div>
    <div class="company-banner">
      <img :src="companyProfileBannerImage" alt="">
      <div>
        <banner-page-view
          :titleObj="companyBannerObj"
        ></banner-page-view>
      </div>
    </div>
    <div class="company-content-box">
      <p class="content-title">上海<span>金保证</span>网络科技有限公司</p>
      <h6>Shanghai golden guarantee network technology co. LTD</h6>
      <p class="introduce">上海金保证网络科技有限公司，地处上海漕河泾，公司主力产品
        “斗票网”是全国首家真正电影比价购票平台，其中聚合猫眼、淘票票、百度糯米等7家主
        流电影票购票平台，实现轻松购票、快乐购票，旨在为用户提供最实惠低价的电影票，目前C
        端有百万级APP、微信用户、B端有工商银行、农业银行、交通银行、建设银行、北京银行
        、光大银行、中国银行等超级体量客户。</p>
      <div class="content-footer flex-middle-x layout-flex-justify-content_space-between">
        <div class="year-box">
          <img :src="yearImage" alt="">
        </div>
        <div class="strategy">
          <img :src="strategyImage" alt="">
        </div>
      </div>
    </div>
    <div class="footer-page-box">
      <footer-page-view
      ></footer-page-view>
    </div>
  </div>
</template>
<script>
  export default {
    name:'',
    data(){
      return {
        companyProfileBannerImage: require('./image/company-profile-banner-image.jpg'),
        companyBannerObj:{
          mainHeading:'公司简介',
          subhead:'力致打造行业领导者',
          content:'Shanghai golden guarantee network technology co. LTD'
        },
        strategyImage:require('./image/strategy-image.png'),
        yearImage:require('./image/year-image.jpg')
      }
    }
  }
</script>
<style lang="scss" rel="stylesheet/scss" scoped="">
  .company-page-view{
    width:100%;
    min-width:1200px;
    background:$color-4;
    .nav-page-box{
      width:100%;
    }
    .company-banner{
      width:100%;
      min-width:1200px;
      position: relative;
      height:450px;
      overflow: hidden;
      img{
        width:100%;
        min-height:450px;
      }
      div{
        width:600px;
        position: absolute;
        top:50%;left:50%;
        transform: translate(-50%, -50%);
      }
    }
    .company-content-box{
      max-width:1200px;
      margin:60px auto;
      text-align: left;
      .content-title{
        font-size:30px;
        color:#555555;
        span{
          color:#ffd36a;
        }
      }
      h6{
        font-size:22px;
        color:#c2c2c2;
        margin-top:10px;
      }
      .introduce{
        font-size:16px;
        color:$color-black;
        margin-top:20px;
      }
      .content-footer{
        max-width:1200px;
        margin-top:70px;
        .year-box{
          width:500px;
          height:700px;
          img{
            width:100%;
          }
        }
        .strategy{
          width:500px;
          img{
            width:100%;
          }
        }
      }
    }
    .footer-page-box{
      width:100%;
    }
  }
</style>
